export default {
  phone: {
    name: 'Phone',
    value: '+48 884 828 647',
    uri: 'tel:+48884828647'
  },
  mail: {
    name: 'Mail',
    value: 'ciunkos@gmail.com',
    uri: 'mailto:ciunkos@gmail.com'
  },
  website: {
    name: 'Website',
    value: 'ciunkos.com',
    uri: 'https://ciunkos.com',
    classes: {
      'media-only-print': true
    }
  },
  gitHubWork: {
    name: 'GitHub (work)',
    value: 'github.com/przemyslawzalewski',
    uri: 'https://github.com/przemyslawzalewski',
    classes: {
      'media-only-print': true
    }
  }
}
